"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getDefaultHeaders(wardenToken) {
    return {
        Accept: "application/json",
        Authorization: "Bearer " + wardenToken
    };
}
exports.default = getDefaultHeaders;
